import * as React from "react";
import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "block min-h-[44px] w-full rounded-[4px] border border-border bg-white px-3 py-2 text-left text-sm text-card-foreground outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-muted-foreground focus:border-primary focus:shadow-[var(--input-focus-shadow)] focus:ring-0 focus-visible:border-primary focus-visible:shadow-[var(--input-focus-shadow)] focus-visible:ring-0 disabled:cursor-not-allowed disabled:border-border disabled:bg-background disabled:text-card-foreground disabled:opacity-100",
        className
      )}
      {...props}
    />
  );
}

export { Input };
